import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-four-view',
  templateUrl: './agent-four-view.component.html',
  styleUrls: ['./agent-four-view.component.scss']
})
export class AgentFourViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
